<template>
  <div>
    <button class="invoice-print-btn" @click="printDiv">Print Invoice</button>
    <div
      id="section-to-print"
      style="
        max-width: 800px;
        margin: auto;
        background-color: #fff;
        padding: 30px;
      "
    >
      <table id="respo_table" style="width: 100%; max-width: 800px; margin: auto; padding: 30px">
        <tr>
          <td>
            <table style="width: 100%">
              <tr>
                <td>
                  <a href="/">
                    <img
                      src="../assets/image/logoInvoice.png"
                      alt=""
                      style="margin-bottom: 10px; width: 211px"
                    />
                  </a>
                  <address style="font-style: normal; line-height: 21px">
                    <span
                      style="
                        margin: 0;
                        font-size: 19px;
                        text-transform: capitalize;
                      "
                    >
                      FREDOVERSE TECH PRIVATE LIMITED</span
                    ><br />
                    149N, Diamond Harbour Road, Behala <br />
                    Kolkata West Bengal 700034<br />
                    India<br />
                    GSTIN: 19AAFCF0006R1ZG<br />
                    PAN: AAFCF0006R
                  </address>
                </td>
                <td style="width: 50%; vertical-align: baseline">
                  <table style="width: 100%">
                    <tr>
                      <td
                        style="
                          width: 50%;
                          text-align: right;
                          vertical-align: baseline;
                        "
                      >
                        <span
                          style="
                            font-size: 40px;
                            text-transform: uppercase;
                            color: black;
                          "
                          >Tax invoice</span
                        ><br />
                        <span style="font-weight: bold">{{
                          financialyear
                        }}</span>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <tr>
          <td style="width: 100%; padding-top: 76px">
            <table style="width: 100%">
              <tr>
                <td style="width: 60%">
                  <table style="width: 100%">
                    <tr></tr>
                    <tr>
                      <td>Bill To</td>
                    </tr>
                    <tr>
                      <td style="font-weight: bold">
                        {{ this.$store.state.user.name }}
                      </td>
                    </tr>
                  </table>
                </td>
                <td style="width: 40%; text-align: right">
                  <table style="width: 100%">
                    <tr>
                      <td>Invoice Date :</td>
                      <td>{{ investDateInvoice }}</td>
                    </tr>
                    <tr>
                      <td>Terms :</td>
                      <td>Online Payment</td>
                    </tr>
                    <tr>
                      <td>Due Date :</td>
                      <td>{{ investDateInvoice }}</td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td style="padding: 12px 5px">Place Of Supply: Kolkata (19)</td>
        </tr>
        <tr>
          <td>
            <table
              style="width: 100%; border-bottom: 1px solid #3b3d39"
              border="0"
              cellspacing="0"
            >
              <thead>
                <tr style="border: 1px solid #3b3d39">
                  <th
                    style="
                      color: #000;
                      font-size: 16px;
                      padding: 6px 0;
                      width: 57px;
                    "
                  >
                    #
                  </th>
                  <th
                    style="
                      width: 199px;
                      color: #000;
                      text-align: left;
                      padding: 6px 0;
                      font-size: 16px;
                    "
                  >
                    Item & Description
                  </th>
                  <th
                    style="
                      color: #000;
                      font-size: 16px;
                      width: 131px;
                      padding: 6px 0;
                    "
                  >
                    Qty
                  </th>
                  <th
                    style="
                      color: #000;
                      font-size: 16px;
                      width: 131px;
                      padding: 6px 0;
                    "
                  >
                    Rate
                  </th>
                  <th
                    style="
                      color: #000;
                      font-size: 16px;
                      width: 131px;
                      padding: 6px 0;
                    "
                  >
                    IGST
                  </th>
                  <th
                    style="
                      color: #000;
                      font-size: 16px;
                      text-align: end;
                      padding: 6px 10px 6px 0px;
                    "
                  >
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="text-align: center; padding: 10px 0">1</td>
                  <td style="text-align: left; padding: 10px 0">
                    Processing Charges
                    <small>Invested Amount: {{ investAmountInvoice }}</small>
                  </td>
                  <td style="text-align: center; padding: 10px 0">1</td>
                  <td style="text-align: center; padding: 10px 0">2%</td>
                  <td style="text-align: center; padding: 10px 0">18%</td>
                  <td
                    style="
                      text-align: center;
                      padding: 10px 0;
                      text-align: end;
                      padding-right: 11px;
                    "
                  >
                    {{ ((investAmountInvoice * 2) / 100).toFixed(2) }}
                  </td>
                </tr>
                <!-- <tr>
                    <td style="text-align: center; padding: 10px 0">2</td>
                    <td style="text-align: left; padding: 10px 0">Discount</td>
                    <td style="text-align: center; padding: 10px 0">-</td>
                    <td style="text-align: center; padding: 10px 0">-</td>
                    <td style="text-align: center; padding: 10px 0"></td>
                    <td
                        style="
                        text-align: center;
                        padding: 10px 0;
                        text-align: end;
                        padding-right: 11px;
                        "
                    >
                        -
                    </td>
                    </tr> -->
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style="width: 40%">
            <table
              cellspacing="0"
              cellpadding=""
              style="width: 100%; text-align: right"
            >
              <tr>
                <td style="padding-bottom: 10px">Sub Total</td>
                <td
                  style="width: 34%; padding-right: 11px; padding-bottom: 10px"
                >
                  {{ processingFee.toFixed(2) }}
                </td>
              </tr>
              <tr>
                <td style="padding-bottom: 10px">IGST18 (18%)</td>
                <td style="padding-right: 11px; padding-bottom: 10px">
                  {{ ((processingFee * 18) / 100).toFixed(2) }}
                </td>
              </tr>
              <tr v-show="percentageVal > 0">
                <td style="padding-bottom: 10px">
                  Discount ({{ percentageDisc }}%)
                </td>
                <td style="padding-right: 11px; padding-bottom: 10px">
                  -{{ percentageVal }}
                </td>
              </tr>
              <tr>
                <td style="font-weight: bold">Total</td>
                <td
                  style="
                    font-weight: bold;
                    padding-right: 11px;
                    padding-bottom: 10px;
                  "
                >
                  {{ invoiceTotal - percentageVal }}
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td style="width: 100%; padding: 72px 0px 7px">
            <table>
              <tr>
                <td
                  style="
                    font-weight: bold;
                    color: #000;
                    text-transform: capitalize;
                  "
                >
                  name:
                </td>
                <td>Pratibha Jain</td>
              </tr>
              <tr>
                <td
                  style="
                    font-weight: bold;
                    color: #000;
                    text-transform: capitalize;
                  "
                >
                  Designation:
                </td>
                <td>Authorized Signatory</td>
              </tr>
              <tr>
                <td colspan="2" align="right">
                  <img
                    style="width: 170px"
                    src="data:image/jpeg;base64,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"
                  />
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td>
            <table>
              <tr>
                <td style="color: #000; line-height: 25px">
                  Terms & Conditions:<br />
                  a) This invoice is payable by electronic transfer /<br />
                  &nbsp;&nbsp;&nbsp; DD / Cheque in favour of Fredoverse Tech
                  Pvt Ltd<br />
                  b) Queries can be sent to
                  <a href="mailto:hello@fredoverse.com">hello@fredoverse.com</a
                  ><br />
                  c) This is a computer generated invoice.
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      investDateInvoice: localStorage.getItem("investDate"),
      investAmountInvoice: localStorage.getItem("investAmount"),
    };
  },
  methods: {
    printDiv() {
      window.print();
    },
  },
  computed: {
    processingFee() {
      const invAmount = localStorage.getItem("investAmount");
      return invAmount * (2 / 100);
    },
    invoiceTotal() {
      return (this.processingFee + (this.processingFee * 18) / 100).toFixed(2);
    },
    percentageVal() {
      return (
        (this.processingFee * localStorage.getItem("discountValue")) / 100 +
        (this.processingFee * 18) / 100
      ).toFixed(2);
    },
    percentageDisc() {
      return localStorage.getItem("discountValue");
    },
    financialyear() {
      var fiscalyear = "";
      var today = new Date();
      if (today.getMonth() + 1 <= 3) {
        fiscalyear =
          (today.getFullYear() - 1).toString().slice(-2) +
          "-" +
          today.getFullYear().toString().slice(-2);
      } else {
        fiscalyear =
          today.getFullYear().toString().slice(-2) +
          "-" +
          (today.getFullYear() + 1).toString().slice(-2);
      }
      const getId = (num) => {
        return num.toString().padStart(5, "0");
      };
      return (
        "#FTPL/" + fiscalyear + "/PC/" + getId(localStorage.getItem("index"))
      );
    },
  },
};
</script>

<style lang="postcss" scoped>
.invoice-print-btn {
  /* margin-top: 0.75rem; */
  width: auto;
  text-align: center;
  border-radius: 0.858rem;
  background-color: var(--color-fotxthd);
  padding: 0.75rem;
  font-size: 1.125rem;
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
  display: inherit;
  margin: 0 auto 30px;
}
@media print {
  body *,
  header {
    visibility: hidden;
  }
  #section-to-print,
  #section-to-print * {
    visibility: visible;
  }
  #section-to-print {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 1000;
  }
}
@media (max-width: 992px) {
  #section-to-print {
    @apply overflow-x-auto !important;
  }
  #respo_table{
    @apply min-w-[700px] !important;
  }
}
</style>
